import { useQuery } from '@apollo/client/react';
import type { DeviceInfoQuery, DeviceInfoQueryVariables } from '../../../../client/__generated__/graphql-client-types';
import { DEVICE_INFO } from '../../../queries/device/device.queries';

export type DeviceInfo = {
	isBot: boolean;
	botScore: number | null;
};

const defaultDeviceInfo: DeviceInfo = {
	isBot: false,
	botScore: null
};

export const useDeviceInfo = () => {
	const { data, loading } = useQuery<DeviceInfoQuery, DeviceInfoQueryVariables>(DEVICE_INFO, {
		fetchPolicy: 'cache-first'
	});

	const deviceInfo: DeviceInfo = data?.device ? data.device : defaultDeviceInfo;

	return { data: deviceInfo, loading };
};
